
try {
    window.$ = window.jQuery = require('jquery');

    require('jquery-ui/ui/effects/effect-slide.js');
    //require('jquery-ui/ui/widgets/datepicker.js');
    //require('jquery-ui/ui/i18n/datepicker-hr.js');

    require('magnific-popup');

    window.Swal = require('sweetalert2');

    require('waypoints/lib/jquery.waypoints.min.js');

    //require('jcarousel');

    //require('bootstrap-star-rating');

    //require('owl.carousel');


} catch (e) {}



$(document).ready(function() {


    $('body').waypoint(function (direction) {
        if (direction === 'down') {
            $('#main-navbar').addClass('main-navbar-stick');
            $('#back-top').removeClass('back-top-hide');
            $('#upper-navbar').addClass("upper-navbar-hide");
        } else {
            $('#main-navbar').removeClass('main-navbar-stick');
            $('#back-top').addClass('back-top-hide');
            $('#upper-navbar').removeClass("upper-navbar-hide");
        }
    }, {
        offset: '-20px'
    });

    $("#back-top").click(function () {
        $("html, body").stop().animate({
            scrollTop: 0
        }, 1500, "easeInOutExpo")
    });

    $('.popup-gallery').magnificPopup({
        delegate: 'a',
        type: 'image',
        tLoading: 'Učitavanje #%curr%...',
        mainClass: 'mfp-img-mobile',
        gallery: {
            enabled: true,
            navigateByImgClick: true,
            preload: [0,1]
        },
        image: {
            tError: '<a href="%url%">Sliku #%curr%</a> nije moguce ucitati.',
        }
    });

    if ($(window).width() > 952) {

        $('ul.nav .dropdown').hover(function() {
            $(this).find('.dropdown-menu').first().stop(true, true).delay(250).slideDown();

        }, function() {
            $(this).find('.dropdown-menu').first().stop(true, true).delay(200).slideUp();

        });

        $('ul.nav .dropdown > a').click(function() {
            location.href = this.href;
        });

        $( ".dropdown-hover" )
        .mouseover(function() {
            $( this ).find('.dropdown-toggle').addClass('show').attr('aria-expanded',"true");
            $( this ).find('.dropdown-menu').addClass('show');
        })
        .mouseout(function() {
            $( this ).find('.dropdown-toggle').removeClass('show').attr('aria-expanded',"false");
            $( this ).find('.dropdown-menu').removeClass('show');
        });
    } else {

        // Mobilni meni
        $('ul.nav .dropdown-toggle').click(function(t) {
            $(this).next('ul').toggle();
            t.preventDefault();
            t.stopPropagation();
        });


    }

    $('.mobile-collapse').on('click', function() {
        $(this).parent().toggleClass('active');
    });
});